/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Kind_StoryInputs */

const vi_shop_home_kind_story = /** @type {(inputs: Shop_Home_Kind_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Câu chuyện`)
};

/**

* @param {Shop_Home_Kind_StoryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_kind_story = /** @type {((inputs?: Shop_Home_Kind_StoryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Kind_StoryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_kind_story(inputs)
});